var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "node_model" }, [
    _c("div", { class: { node_model_box: true, finish_mode_box: true } }, [
      _c("div", { staticClass: "left_box" }, [
        _c("div", {
          staticClass: "left_up_line",
          style: _vm.getStyleFromConfigs(0)
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "left_down_line",
          style: _vm.getStyleFromConfigs(1)
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "center_box" },
        [
          _c("div", {
            staticClass: "left_horiz_line",
            style: _vm.getStyleFromConfigs(2)
          }),
          _vm._v(" "),
          _c(
            "el-popover",
            {
              attrs: {
                placement: "right-start",
                trigger: "hover",
                "close-delay": 50,
                disabled: _vm.status !== "0" && _vm.status !== "4"
              }
            },
            [
              _vm.status === "0"
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "row",
                        "align-items": "stretch",
                        "font-size": "12px"
                      },
                      style: {
                        color: _vm.jobType === "app" ? "#276FF5" : "#FF5F1F"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                            "flex-shrink": "0"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.jobType === "app"
                                ? _vm.getLangMsg("soenoderender_001")
                                : _vm.getLangMsg("soenoderender_002")
                            )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticStyle: {
                          width: "1px",
                          background: "black",
                          margin: "5px 8px"
                        },
                        style: {
                          background:
                            _vm.jobType === "app" ? "#E0EFFF" : "#FFE7D6"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column"
                          }
                        },
                        _vm._l(_vm.jobDetails, function(item) {
                          return _c("div", [_vm._v(_vm._s(item))])
                        }),
                        0
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.status === "4"
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "row",
                        "align-items": "stretch",
                        "font-size": "12px"
                      }
                    },
                    [
                      _c("div", { staticStyle: { color: "#FB2323" } }, [
                        _vm._v(_vm._s(_vm.getLangMsg("soenoderender_003")))
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticStyle: {
                          width: "1px",
                          background: "#E5E5E5",
                          margin: "5px 8px"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column",
                            color: "#212121"
                          }
                        },
                        [_vm._v(_vm._s(_vm.message))]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { attrs: { slot: "reference" }, slot: "reference" }, [
                _vm.nodeObj["nodeId"] != null &&
                _vm.nodeObj["nodeId"].includes("StartSignal")
                  ? _c("div", { staticClass: "startNode" }, [
                      _c("img", {
                        staticStyle: { width: "21px" },
                        attrs: { src: _vm.startImgUrl, alt: "" }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "font-size": "12px",
                            "margin-left": "2px"
                          }
                        },
                        [_vm._v(_vm._s(_vm.getLangMsg("soenoderender_004")))]
                      )
                    ])
                  : _c(
                      "div",
                      {
                        class: _vm.statusClassMap[_vm.status],
                        style: _vm.getStyleFromConfigs(3),
                        on: {
                          click: function($event) {
                            return _vm.clickNode(_vm.nodeObj)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "details" }, [
                          _c(
                            "span",
                            {
                              staticClass: "name",
                              attrs: { title: _vm.nodeObj.name }
                            },
                            [_vm._v(_vm._s(_vm.nodeObj.name))]
                          )
                        ])
                      ]
                    )
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "right_horiz_line",
            style: _vm.getStyleFromConfigs(4)
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "right_box" }, [
        _c("div", {
          staticClass: "right_up_line",
          style: _vm.getStyleFromConfigs(5)
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "right_down_line",
          style: _vm.getStyleFromConfigs(6)
        })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }